import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../common/Button';
import styles from './Header.module.css';
import { Bell } from 'lucide-react';

const NotificationBell = ({ count = 0, onClick }) => (
  <button className={styles.notificationBell} onClick={onClick}>
    <Bell className={styles.bellIcon} />
    {count > 0 && <span className={styles.badge}>{count}</span>}
  </button>
);

export const Header = ({ 
  title = 'Dashboard',
  subtitle,
  actions,
  rightActions,
  notifications
}) => {
  return (
    <header className={styles.header}>
      <div className={styles.titleSection}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>

      <div className={styles.actionsSection}>
        {rightActions && (
          <div className={styles.rightActions}>
            {rightActions.map((action, index) => (
              <Button
                key={index}
                variant={action.variant || 'secondary'}
                size={action.size || 'small'}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))}
          </div>
        )}
        <NotificationBell count={notifications?.count} onClick={notifications?.onClick} />
      </div>
    </header>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.string,
    size: PropTypes.string
  })),
  rightActions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.string,
    size: PropTypes.string
  })),
  notifications: PropTypes.shape({
    count: PropTypes.number,
    onClick: PropTypes.func
  })
};

